import React from "react";

import { TiTick } from "react-icons/ti";

import { IoIosArrowForward as ArrowForwardIosSharpIcon } from "react-icons/io";

import { styled } from "@mui/material/styles";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import yellowwave from "../../../../assets/images/yellow-wave.svg";
import yellow1 from "../../../../assets/images/yellow1.svg";
import bluewave from "../../../../assets/images/blue-wave.svg";
import blue2 from "../../../../assets/images/blue2.svg";

import { Parallax } from "react-parallax";

import "./RoadMap.scss";

let greenData = [
  {
    title: "Reveal",
    date: "August 2018",
    detail:
      "Total supply of 5,555 Angry Dwarves Tribe NFT'S. A Limited number of Angry Dwarves will be provided for FREE to members with proof of Rich Dwarves Tribe NFT ownership. The first free Angry Dwarves will be given in Phase One, and the second will be given in Phase 3.",
  },
  {
    title: "Rewards",
    date: "August 2021",
    detail:
      "The Tribe works with most of the treasure chest to increase the treasure (speculate to accumulate). At regular intervals, the treasure chest is increased with profits from the various projects and thus strengthens the value of the $ORE held.  ",
    detail1:
      "When selecting our projects, we attach great importance to the possibility of generating passive income while spreading the risk over several forms of investment. The selection is made by the tribe via way of a poll. Every ADT NFT holder can bring in suggestions for interesting projects.",
    detail2:
      "In addition, a part of the treasure chest will be invested in the acquisition of whitelist positions for other doxxed projects. The tribe can use these whitelist positions to take the projects into the treasury and use profits to increase the treasury. The Tribe may also choose to sell or auction Whitelist positions for $ORE.",
  },
  {
    title: "100%  ",
    title1: "Royalties",
    date: "September 2021",
    detail:
      "100% of secondary sales will be distributed back within the community.",
    detail1:
      "All royalties will be distributed to our liquidity pool - this allows Angry Dwarves holders to claim the surplus from royalties every 90 days in $ORE.",
  },
  {
    title: "Passive",
    title1: " Income",
    date: "October 2021",
    detail:
      "The Tribe is currently working on the representation of an ETH/$ORE Pool. Mined $ORE can be exchanged for any currency here in the future. According to our investment plan, we aim to double the pool within a short time period.",
    detail1:
      "Due to the permanent and regular increases in the pool, it is worth holding the shares for a long time.",
  },
  {
    title: "Ethereum ",
    title1: " Mining",

    date: "October 2021",
    detail:
      "5% of our gross mint revenue will be invested into an Ethereum mining operation",
  },
  {
    title: "Passive",
    title1: " Potential",

    date: "October 2021",
    detail:
      "The financials have been calculated based on product cost, electricity cost, current live price of ETH, storage facility and maintenance. The Ethereum mining operation is a proof of concept to allow time to assess whether or not this can become a long term solution to generate passive income for the community.",
  },
  {
    title: "Passive ",
    title1: " Rewards",

    date: "October 2021",
    detail:
      "After the initial costs are recouped any profit will be invested to our liquidity pool to provide further passive income for ADT holders. the process will be replicated from the royalties staking where you must hold your NFT for 90 days to claim the $ORE rewards from mining operations.",
  },
  {
    title: "Angry Dwarves into the Metaverse",

    date: "October 2021",
    detail:
      "The Angry Dwarves Tribe will have their very own land in an existing metaverse. Other features to be discussed as a community for utility inside the Metaverse. We will seek to purchase land in both Sandbox & Decentraland after mint - this will enable our other Utilities (TBA) to develop and form over the coming months and for our other seasons!",
  },
];

let faqData = [
  {
    title: "What is Angry Dwarves NFT?",

    detail:
      "We are a community driven NFT project . 100% community owned, All money generated from the projects sales will be re-invested to further grow the project.",
  },
  {
    title: "When is mint date ?",

    detail:
      "Mint date will be in APRIL - a final date will be released in due course.",
  },
  {
    title: "Is the project DOXXED?",

    detail:
      "Yes the project is fully doxxed. We have a project team & treasury team who are fully doxxed. Their profiles are available in our discord or above.",
  },
  {
    title: "What are your main utilities?",

    detail:
      "Our main Utilities for Phase 1 will be staking, Ehtererum mining operations & metaverse purchases.",
  },
];

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  backgroundColor: "#1e162d",
  width: "calc(50% - 31px)",
  fontFamily: "Poppins",
  margin: "0 0 2rem 0",
  color: "white",
  border: `none`,
  padding: ".5rem",
  borderRadius: ".7rem",
  cursor: "pointer",
  "&::hover": {
    // backgroundColor: "red"
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon color="white" size="1rem" />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const RoadMap = () => {
  const [expanded, setExpanded] = React.useState("");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <>
      <div className="roadmap_container">
        <div className="box">
          <Parallax
            renderLayer={(percentage) => {
              let t = percentage * 1200;
            }}
          >
            <div className="title"> Roadmap Phase 1</div>

            <div className="data">
              {greenData.map((data, index) => {
                return (
                  <>
                    <div className="acordian_box">
                      <div className="line">
                        <div className="tick">
                          {" "}
                          <TiTick />{" "}
                        </div>
                        {/* <p></p> */}
                      </div>
                      {/* <div className="acordian"> */}
                      <Accordion
                        expanded={expanded === `panel${index + 1}`}
                        onChange={handleChange(`panel${index + 1}`)}
                      >
                        <AccordionSummary
                          aria-controls="panel1d-content"
                          id="panel1d-header"
                        >
                          <div className="name">
                            {/* <div className="done">
                                                                Done
                                                            </div> */}
                            <div className="detail">
                              <p
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "1.2rem",
                                }}
                              >
                                {" "}
                                {data.title}
                                <span
                                  style={{
                                    color: "rgb(255, 217, 0)",
                                    fontWeight: "bold",
                                    fontSize: "1.2rem",
                                  }}
                                >
                                  {data.title1}
                                </span>
                              </p>

                              {/* <p className='date'> {data.date} </p> */}
                            </div>
                          </div>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography>{data.detail}</Typography>
                          <Typography>{data.detail1}</Typography>
                          <Typography>{data.detail2}</Typography>
                        </AccordionDetails>
                      </Accordion>

                      {/* </div> */}
                    </div>

                    {/* <div className="acordian"> */}
                  </>
                );
              })}
            </div>
          </Parallax>
        </div>
        <img
          src={blue2}
          alt=""
          style={{ width: "150%", margin: "0% 0% 0% -24%" }}
        />

        <div className="box1">
          <Parallax>
            <div className="title"> FAQ </div>
            <div className="data">
              {faqData.map((fdata) => {
                return (
                  <>
                    <div className="acordian_box">
                      {/* <div className="acordian"> */}
                      <Accordion>
                        <AccordionSummary aria-controls="panel1d-content" id="">
                          <div className="name">
                            <div className="detail">
                              <p
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "1.2rem",
                                }}
                              >
                                {" "}
                                {fdata.title}{" "}
                              </p>
                            </div>
                          </div>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography>{fdata.detail}</Typography>
                          <Typography>{fdata.detail1}</Typography>
                          <Typography>{fdata.detail2}</Typography>
                          <Typography>{fdata.detail3}</Typography>
                          <Typography>{fdata.detail4}</Typography>
                          <Typography>{fdata.detail5}</Typography>
                          <Typography>{fdata.detail6}</Typography>
                          <Typography>{fdata.detail7}</Typography>
                          <Typography>{fdata.detail8}</Typography>
                          <Typography>{fdata.detail9}</Typography>
                          <Typography>{fdata.detail10}</Typography>
                          <Typography>{fdata.detail11}</Typography>
                        </AccordionDetails>
                      </Accordion>
                    </div>
                  </>
                );
              })}
            </div>
          </Parallax>
        </div>

        <img
          src={yellow1}
          alt=""
          style={{ width: "150%", margin: "0% 0% 0% -24%" }}
        />
        {/* <div className='badgediv' style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <img className='badgeimg' src={badge} />
                </div> */}
      </div>
    </>
  );
};

export default RoadMap;
